import { render, staticRenderFns } from "./InvestResult.vue?vue&type=template&id=a9175d22&scoped=true&"
import script from "./InvestResult.vue?vue&type=script&lang=js&"
export * from "./InvestResult.vue?vue&type=script&lang=js&"
import style0 from "./InvestResult.vue?vue&type=style&index=0&id=a9175d22&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9175d22",
  null
  
)

component.options.__file = "InvestResult.vue"
export default component.exports